<!-- Notification Bell Icon -->
<div class="relative">
  <button 
    (click)="togglePanel()"
    class="relative p-2 hover:bg-blue-700/20 rounded-lg transition-colors cursor-pointer"
  >
    <img src="assets/logos/notifications-icon.svg" alt="Notifications" class="w-6 h-6">
  </button>

  <!-- Notification Panel -->
  @if (isOpen) {
    <div class="absolute right-0 mt-2 w-52 h-24 bg-white rounded-lg shadow-2xl border border-gray-200 z-50">
      <!-- Header -->
      <div class="flex items-center justify-between p-2 border-b border-gray-200 bg-[#00358E] rounded-t-lg">
        <h3 class="text-sm font-medium text-white">Notifications</h3>
        <img src="assets/logos/clientmodal-close-icon.svg"
          (click)="closePanel()"
          class="color-white hover:gray-200 hover:cursor-pointer"
        >
      </div>
      <!-- Empty State -->
      <div class="flex flex-col items-center justify-center bg-white py-4 px-4 text-gray-400 rounded-b-lg">
        <p class="text-sm text-gray-500 mt-1">You don't have any notifications right now</p>
      </div>
    </div>
  }
</div>

<!-- Backdrop -->
@if (isOpen) {
  <div 
    (click)="closePanel()"
    class="fixed inset-0 z-40"
    style="background: transparent;"
  ></div>
}
